import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled, { css } from 'styled-components';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var TagType;

(function (TagType) {
  TagType["Default"] = "default";
  TagType["Success"] = "success";
  TagType["Danger"] = "danger";
})(TagType || (TagType = {}));

var _templateObject, _templateObject2, _templateObject3, _TagStyle, _templateObject4, _templateObject5;
var TagStyle = (_TagStyle = {}, _defineProperty(_TagStyle, TagType.Default, {
  normal: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.black;
  }, function (p) {
    return p.theme.palette.gray['200'];
  })
}), _defineProperty(_TagStyle, TagType.Success, {
  normal: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.green['500'];
  })
}), _defineProperty(_TagStyle, TagType.Danger, {
  normal: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.red['700'];
  })
}), _TagStyle);
var TagContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  width: fit-content;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 3px 6px;\n  border-radius: 4px;\n  ", ";\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return TagStyle[p.$type].normal;
});
var Tag$1 = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 14px;\n"])));

function Tag(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? TagType.Default : _ref$type,
      disabled = _ref.disabled,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(TagContainer, {
    className: className,
    disabled: disabled,
    $type: type
  }, /*#__PURE__*/React.createElement(Tag$1, null, children)));
}

export { Tag, TagType };
